import { NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/formbird-types.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormbirdTypesModule {
}
FormbirdTypesModule.decorators = [
    { type: NgModule, args: [{
                declarations: [],
                imports: [],
                exports: []
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/types/document-data.type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * type for a documentData, used for passing details about the loaded document around
 * @record
 */
function DocumentData() { }
if (false) {
    /** @type {?} */
    DocumentData.prototype.template;
    /** @type {?} */
    DocumentData.prototype.document;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/types/document-info.type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function DocumentInfo() { }
if (false) {
    /** @type {?|undefined} */
    DocumentInfo.prototype.templateId;
    /** @type {?|undefined} */
    DocumentInfo.prototype.documentId;
    /** @type {?|undefined} */
    DocumentInfo.prototype.overrideTemplateId;
    /** @type {?|undefined} */
    DocumentInfo.prototype.showFormAfterCreated;
    /** @type {?|undefined} */
    DocumentInfo.prototype.isNew;
    /** @type {?|undefined} */
    DocumentInfo.prototype.name;
    /** @type {?|undefined} */
    DocumentInfo.prototype.isMainDoc;
    /** @type {?|undefined} */
    DocumentInfo.prototype.altTemplateId;
    /** @type {?|undefined} */
    DocumentInfo.prototype.hierarchyInfo;
    /** @type {?|undefined} */
    DocumentInfo.prototype.options;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/types/form-document.type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function FormDocument() { }
if (false) {
    /** @type {?} */
    FormDocument.prototype.documentId;
    /** @type {?|undefined} */
    FormDocument.prototype.name;
    /** @type {?|undefined} */
    FormDocument.prototype.systemHeader;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/types/hierarchy-document-Info.type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function HierarchyDocumentInfo() { }
if (false) {
    /** @type {?|undefined} */
    HierarchyDocumentInfo.prototype.parentDocumentId;
    /** @type {?|undefined} */
    HierarchyDocumentInfo.prototype.childDocumentId;
    /** @type {?|undefined} */
    HierarchyDocumentInfo.prototype.documentId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/types/form-parameters.type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function FormParameters() { }
if (false) {
    /** @type {?} */
    FormParameters.prototype.selectedDocumentId;
    /** @type {?} */
    FormParameters.prototype.unsavedDocumentListId;
    /** @type {?|undefined} */
    FormParameters.prototype.overrideTemplateId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/types/logged-in-user-info.type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * class for a user
 */
/**
 * @record
 */
function LoggedInUserInfo() { }
if (false) {
    /** @type {?} */
    LoggedInUserInfo.prototype.welcomeMsg;
    /** @type {?} */
    LoggedInUserInfo.prototype.account;
    /** @type {?} */
    LoggedInUserInfo.prototype.filteredAccount;
    /** @type {?} */
    LoggedInUserInfo.prototype.menu;
    /** @type {?} */
    LoggedInUserInfo.prototype.publicAccount;
    /** @type {?} */
    LoggedInUserInfo.prototype.accountPublicURL;
    /** @type {?} */
    LoggedInUserInfo.prototype.accountControlDocument;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/types/offline-status-type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * type for the offline status, to be used for tracking and displaying information about the offline status
 * @record
 */
function OfflineStatus() { }
if (false) {
    /** @type {?} */
    OfflineStatus.prototype.unsyncedCount;
    /** @type {?} */
    OfflineStatus.prototype.connected;
    /** @type {?} */
    OfflineStatus.prototype.connectionText;
    /** @type {?} */
    OfflineStatus.prototype.incomingCacheCount;
    /** @type {?} */
    OfflineStatus.prototype.maxCacheCount;
    /** @type {?} */
    OfflineStatus.prototype.currentCacheCount;
    /** @type {?} */
    OfflineStatus.prototype.cacheLoading;
    /** @type {?} */
    OfflineStatus.prototype.pendingDocumentCount;
    /** @type {?} */
    OfflineStatus.prototype.errorCacheCount;
    /** @type {?} */
    OfflineStatus.prototype.initialCachingComplete;
    /** @type {?} */
    OfflineStatus.prototype.cachingApp;
    /** @type {?} */
    OfflineStatus.prototype.currentStaticResourceCount;
    /** @type {?} */
    OfflineStatus.prototype.totalStaticResourceCount;
    /** @type {?} */
    OfflineStatus.prototype.tileServerCacheCount;
    /** @type {?} */
    OfflineStatus.prototype.tileServerMaxCacheCount;
    /** @type {?} */
    OfflineStatus.prototype.errorCacheAttachedFile;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/types/page-download-progress.type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * type for page download progress. This is used in offline status service but could also be used for other purposes like search
 * page download progress
 * @record
 */
function PageDownloadProgress() { }
if (false) {
    /** @type {?} */
    PageDownloadProgress.prototype.pageNumber;
    /** @type {?} */
    PageDownloadProgress.prototype.loaded;
    /** @type {?} */
    PageDownloadProgress.prototype.total;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/types/system-header.type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * class for the systemHeader that appears in documents
 */
class SystemHeader {
}
if (false) {
    /** @type {?} */
    SystemHeader.prototype.summaryName;
    /** @type {?} */
    SystemHeader.prototype.summaryDescription;
    /** @type {?} */
    SystemHeader.prototype.systemType;
    /** @type {?} */
    SystemHeader.prototype.templateId;
    /** @type {?} */
    SystemHeader.prototype.versionId;
    /** @type {?} */
    SystemHeader.prototype.previousVersionId;
    /** @type {?} */
    SystemHeader.prototype.createdWith;
    /** @type {?} */
    SystemHeader.prototype.excludeGeneralSearch;
    /** @type {?} */
    SystemHeader.prototype.currentVersion;
    /** @type {?} */
    SystemHeader.prototype.createdDate;
    /** @type {?} */
    SystemHeader.prototype.serverCreatedDate;
    /** @type {?} */
    SystemHeader.prototype.serverUpdatedDate;
    /** @type {?} */
    SystemHeader.prototype.createdBy;
    /** @type {?} */
    SystemHeader.prototype.keyIds;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/types/FtError.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FtError extends Error {
}
if (false) {
    /** @type {?} */
    FtError.prototype.status;
    /** @type {?} */
    FtError.prototype.statusText;
    /** @type {?} */
    FtError.prototype.data;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/types/user.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * class for a user
 */
/**
 * @record
 */
function User() { }
if (false) {
    /** @type {?} */
    User.prototype.welcomeMsg;
    /** @type {?} */
    User.prototype.account;
    /** @type {?} */
    User.prototype.filteredAccount;
    /** @type {?} */
    User.prototype.menu;
    /** @type {?} */
    User.prototype.publicAccount;
    /** @type {?} */
    User.prototype.accountPublicURL;
    /** @type {?} */
    User.prototype.accountControlDocument;
    /** @type {?} */
    User.prototype.accountGroupConfigDocument;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/types/component-definition.type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * class for the entries in the components array of a template
 * @record
 */
function ComponentDefinition() { }
if (false) {
    /** @type {?|undefined} */
    ComponentDefinition.prototype.componentName;
    /** @type {?|undefined} */
    ComponentDefinition.prototype.type;
    /** @type {?|undefined} */
    ComponentDefinition.prototype.name;
    /** @type {?|undefined} */
    ComponentDefinition.prototype.label;
    /** @type {?|undefined} */
    ComponentDefinition.prototype.mandatory;
    /** @type {?|undefined} */
    ComponentDefinition.prototype.defaultValue;
    /** @type {?|undefined} */
    ComponentDefinition.prototype.enabled;
    /** @type {?|undefined} */
    ComponentDefinition.prototype.fullWidth;
    /** @type {?|undefined} */
    ComponentDefinition.prototype.readOnly;
    /** @type {?|undefined} */
    ComponentDefinition.prototype.disableSave;
    /** @type {?|undefined} */
    ComponentDefinition.prototype.visible;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/types/component-document.type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ComponentDocument() { }
if (false) {
    /** @type {?|undefined} */
    ComponentDocument.prototype.name;
    /** @type {?|undefined} */
    ComponentDocument.prototype.componentType;
    /** @type {?|undefined} */
    ComponentDocument.prototype.vendorLibrariesRel;
    /** @type {?|undefined} */
    ComponentDocument.prototype.vendorLibrariesRelDev;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/types/form-template.type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function FormTemplate() { }
if (false) {
    /** @type {?} */
    FormTemplate.prototype.documentId;
    /** @type {?|undefined} */
    FormTemplate.prototype.name;
    /** @type {?|undefined} */
    FormTemplate.prototype.components;
    /** @type {?|undefined} */
    FormTemplate.prototype.formNavBar;
    /** @type {?|undefined} */
    FormTemplate.prototype.hideCommandBar;
    /** @type {?|undefined} */
    FormTemplate.prototype.formColor;
    /** @type {?|undefined} */
    FormTemplate.prototype.commandBarCSS;
    /** @type {?|undefined} */
    FormTemplate.prototype.vendorLibrariesRel;
    /** @type {?|undefined} */
    FormTemplate.prototype.vendorLibrariesRelDev;
    /** @type {?|undefined} */
    FormTemplate.prototype.loadComponentDocumentDependencies;
    /** @type {?|undefined} */
    FormTemplate.prototype.enableTemplateLoadAnimation;
    /** @type {?|undefined} */
    FormTemplate.prototype.formLoadingImageURL;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/types/form-component.type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function FormComponent() { }
if (false) {
    /** @type {?} */
    FormComponent.prototype.document;
    /** @type {?} */
    FormComponent.prototype.template;
    /** @type {?} */
    FormComponent.prototype.componentDefinition;
    /** @type {?} */
    FormComponent.prototype.fieldValue;
    /** @type {?} */
    FormComponent.prototype.fieldName;
    /** @type {?} */
    FormComponent.prototype.formParameters;
    /** @type {?} */
    FormComponent.prototype.key;
    /** @type {?|undefined} */
    FormComponent.prototype.vendorLibrariesRel;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/types/related-document.type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * class for a related document
 */
/**
 * @record
 */
function RelatedDocument() { }
if (false) {
    /** @type {?} */
    RelatedDocument.prototype.documentId;
    /** @type {?} */
    RelatedDocument.prototype.name;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/types/vendor-library.type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * class for a vendor library, loaded from templates and components
 * @record
 */
function VendorLibrary() { }
if (false) {
    /** @type {?} */
    VendorLibrary.prototype.fileName;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/types/ruleset-document-context.type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function RulesetDocumentContext() { }
if (false) {
    /** @type {?|undefined} */
    RulesetDocumentContext.prototype.documentData;
    /** @type {?|undefined} */
    RulesetDocumentContext.prototype.fieldChanged;
    /** @type {?|undefined} */
    RulesetDocumentContext.prototype.originValue;
    /** @type {?|undefined} */
    RulesetDocumentContext.prototype.newValue;
    /** @type {?|undefined} */
    RulesetDocumentContext.prototype.oldValue;
    /** @type {?|undefined} */
    RulesetDocumentContext.prototype.templateId;
    /** @type {?|undefined} */
    RulesetDocumentContext.prototype.formParameters;
    /** @type {?|undefined} */
    RulesetDocumentContext.prototype.template;
    /** @type {?|undefined} */
    RulesetDocumentContext.prototype.databaseMode;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/types/document-changed-info.type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function DocumentChangedInfo() { }
if (false) {
    /** @type {?} */
    DocumentChangedInfo.prototype.documentId;
    /** @type {?} */
    DocumentChangedInfo.prototype.fieldName;
    /** @type {?|undefined} */
    DocumentChangedInfo.prototype.oldValue;
    /** @type {?} */
    DocumentChangedInfo.prototype.newValue;
    /** @type {?|undefined} */
    DocumentChangedInfo.prototype.formParameters;
    /** @type {?|undefined} */
    DocumentChangedInfo.prototype.isInitValue;
    /** @type {?|undefined} */
    DocumentChangedInfo.prototype.sourceType;
    /** @type {?|undefined} */
    DocumentChangedInfo.prototype.changedFields;
    /** @type {?|undefined} */
    DocumentChangedInfo.prototype.controlName;
    /** @type {?|undefined} */
    DocumentChangedInfo.prototype.shouldCompareValues;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/types/change-source.type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const ChangeSourceType = {
    COMPONENT: 0,
    RULESET: 1,
    DOCUMENT_PUSH: 2,
};
ChangeSourceType[ChangeSourceType.COMPONENT] = 'COMPONENT';
ChangeSourceType[ChangeSourceType.RULESET] = 'RULESET';
ChangeSourceType[ChangeSourceType.DOCUMENT_PUSH] = 'DOCUMENT_PUSH';
class ChangeSourceInfo {
}
if (false) {
    /** @type {?} */
    ChangeSourceInfo.prototype.type;
    /** @type {?} */
    ChangeSourceInfo.prototype.fieldName;
    /** @type {?} */
    ChangeSourceInfo.prototype.documentId;
    /** @type {?} */
    ChangeSourceInfo.prototype.controlName;
}
class StateChangeInfo {
}
if (false) {
    /** @type {?} */
    StateChangeInfo.prototype.patches;
    /** @type {?} */
    StateChangeInfo.prototype.inversePatches;
    /** @type {?} */
    StateChangeInfo.prototype.recordedUndoRedo;
    /** @type {?} */
    StateChangeInfo.prototype.changedSourceInfo;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/types/field-changes.type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function FieldChanges() { }
if (false) {
    /** @type {?|undefined} */
    FieldChanges.prototype.fieldName;
    /** @type {?|undefined} */
    FieldChanges.prototype.newValue;
    /** @type {?|undefined} */
    FieldChanges.prototype.oldValue;
    /** @type {?|undefined} */
    FieldChanges.prototype.source;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants/SharedConstants.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SharedConstants {
}
SharedConstants.APP_NAME = 'Formbird';
SharedConstants.SYSTEM_TYPE_DOCUMENT = 'document';
SharedConstants.SYSTEM_TYPE_VERSION = 'version';
SharedConstants.SYSTEM_TYPE_TEMPLATE = 'template';
SharedConstants.SYSTEM_TYPE_ACCOUNT = 'account';
SharedConstants.SYSTEM_TYPE_RULESET_DOCUMENT = 'rulesetdocument';
SharedConstants.SYSTEM_TYPE_SYSTEM_ACTION = 'systemaction';
SharedConstants.SYSTEM_TYPE_SCHEDULE = 'schedule';
SharedConstants.SYSTEM_TYPE_FILE_REFERENCE = 'fileReference';
SharedConstants.SYSTEM_TYPE_CONFIGURATION = 'configuration';
SharedConstants.SYSTEM_TYPE_COMPONENT = 'component';
SharedConstants.SYSTEM_TYPE_COUNTER = 'counter';
SharedConstants.SYSTEM_TYPE_PASSWORD_RESET = 'passwordReset';
SharedConstants.SYSTEM_TYPE_ACCOUNT_SECURITY = 'accountSecurity';
SharedConstants.SYSTEM_TYPE_ACCOUNT_CONTROL = 'accountControl';
SharedConstants.SYSTEM_TYPE_ACCOUNT_GROUP_CONFIG = 'accountGroupConfig';
SharedConstants.SYSTEM_TYPE_PASSWORD = 'password';
SharedConstants.SYSTEM_TYPE_RULESET = 'ruleset';
SharedConstants.SYSTEM_TYPE_RULESET_INCLUDE = 'rulesetInclude';
SharedConstants.SYSTEM_TYPE_APPLICATION = 'application';
SharedConstants.SYSTEM_TYPE_VENDOR_LIBRARY = 'vendorLibrary';
SharedConstants.STATUS_PENDING = 'pending';
SharedConstants.STATUS_PROCESSING = 'processing';
SharedConstants.STATUS_PROCESSED = 'processed';
SharedConstants.STATUS_ERROR = 'error';
SharedConstants.STATUS_SUCCESS = 'success';
SharedConstants.STATUS_WARNING = 'warning';
SharedConstants.STATUS_INFO = 'info';
SharedConstants.STATUS_FORBIDDEN = 'forbidden';
SharedConstants.METHOD_POST = 'POST';
SharedConstants.METHOD_GET = 'GET';
SharedConstants.METHOD_DELETE = 'DELETE';
SharedConstants.METHOD_PUT = 'PUT';
SharedConstants.DEFAULT_PAGE = 0;
SharedConstants.DEFAULT_PAGE_SIZE = 50;
SharedConstants.DEFAULT_TOTAL_ITEM = 10000;
SharedConstants.DEFAULT_SEARCH_DELAY = 500;
SharedConstants.DEFAULT_MAX_SEARCH_QUERY_LENGTH = 2048;
SharedConstants.DEFAULT_SEARCH_SELECT_PAGE_SIZE = 5;
SharedConstants.DEFAULT_SEARCH_SELECT_PAGE = 0;
// field types
SharedConstants.FIELD_TYPE_RELATED = 'Related';
SharedConstants.FIELD_TYPE_HTML = 'html';
SharedConstants.FIELD_TYPE_CUSTOM = 'Custom';
SharedConstants.ELASTIC_DOCUMENT_TYPE = 'documents';
SharedConstants.ELASTIC_DOCUMENT_PREFIXES = {
    'mongodb': '_source',
    'couchbase': '_source.doc'
};
SharedConstants.DEFAULT_DB_PROVIDER = 'mongodb';
SharedConstants.DEFAULT_DB_CONNECTION = 'default';
SharedConstants.RULESET_EVENT_NAME = 'EventName';
SharedConstants.RULESET_RELATIONSHIPS = {
    PRERENDER_EVENT_NAME: {
        name: 'PreRender',
        relName: 'preRenderClientRuleRel'
    },
    ONLOAD_EVENT_NAME: {
        name: 'OnLoad',
        relName: 'onLoadClientRuleRel'
    },
    ON_FIELD_CHANGE_EVENT_NAME: {
        name: 'OnFieldChange',
        relName: 'onFieldChangeClientRuleRel'
    },
    PRESAVE_EVENT_NAME: {
        name: 'PreSave',
        relName: 'preSaveClientRuleRel'
    },
    POSTSAVE_CLIENT_EVENT_NAME: {
        name: 'PostSaveClient',
        relName: 'postSaveClientRuleRel'
    },
    PRESAVE_SERVER_EVENT_NAME: {
        name: 'PreSaveServer',
        relName: 'preSaveServerRuleRel'
    },
    POSTSAVE_EVENT_NAME: {
        name: 'PostSave',
        relName: 'postSaveServerRuleRel'
    }
};
SharedConstants.ONLOAD_DONE_RULES_EVENT_NAME = 'OnLoadDone';
SharedConstants.ON_CHANGE_FILTER_EVENT_NAME = 'OnChangeFilter';
SharedConstants.LOCATION_CHANGE_STATE_EVENT = '$locationChangeStart';
SharedConstants.UPDATE_SHOW_VALUE_EVENT = 'updateShowValue';
SharedConstants.EVENT_LIST_NAME = 'eventList';
SharedConstants.EVENT_VALIDATION_VALUES_NAME = 'validationValues';
SharedConstants.INSERT_OPERATION_TYPE = 'Insert';
SharedConstants.UPDATE_OPERATION_TYPE = 'Update';
SharedConstants.CSV_DOC_ID_MATCH_MERGE = 'merge';
SharedConstants.CSV_DOC_ID_MATCH_REPLACE = 'replace';
SharedConstants.CSV_DOC_ID_NO_MATCH_ADD = 'add';
SharedConstants.CSV_DOC_ID_NO_MATCH_ERR = 'error';
// operation types for clicking on navigation bar
SharedConstants.SAVE_CLICK_OPERATION_TYPE = 'SaveClick';
SharedConstants.NEW_CLICK_OPERATION_TYPE = 'NewClick';
SharedConstants.PRINT_CLICK_OPERATION_TYPE = 'PrintClick';
SharedConstants.MAP_CLICK_OPERATION_TYPE = 'MapClick';
// operation types, for checking access
SharedConstants.OPERATION_TYPE_READ = 'Read';
SharedConstants.OPERATION_TYPE_CREATE = 'Create';
SharedConstants.OPERATION_TYPE_UPDATE = 'Update';
SharedConstants.OPERATION_TYPE_DELETE = 'Delete';
SharedConstants.OPERATION_TYPE_EXECUTE = 'Execute';
SharedConstants.OPERATION_TYPE_OFFLINE = 'Offline';
// error types, for server functions
SharedConstants.ERROR_TYPE_NOACCESS = 'No Access';
SharedConstants.ERROR_TYPE_NOTFOUND = 'Not Found';
SharedConstants.ERROR_TYPE_INTERNAL = 'Internal';
SharedConstants.ERROR_TYPE_GONE = 'Gone';
// websocket messages
SharedConstants.WEB_SOCKET_MESSAGE_TEMPLATE_DRAFT_SAVED = 'template_draft_saved';
SharedConstants.WEB_SOCKET_MESSAGE_UPDATE_PREVIEW = 'update_preview';
SharedConstants.WEB_SOCKET_MESSAGE_SAVE_DOCUMENT = 'save_document';
SharedConstants.WEB_SOCKET_MESSAGE_PASSWORD_RESET = 'password_reset';
SharedConstants.HEADING_THRESHOLD_H0 = 22.5;
SharedConstants.HEADING_THRESHOLD_H1 = 67.5;
SharedConstants.HEADING_THRESHOLD_H2 = 112.5;
SharedConstants.HEADING_THRESHOLD_H3 = 157.5;
SharedConstants.HEADING_THRESHOLD_H4 = 202.5;
SharedConstants.HEADING_THRESHOLD_H5 = 247.5;
SharedConstants.HEADING_THRESHOLD_H6 = 292.5;
SharedConstants.HEADING_THRESHOLD_H7 = 337.5;
SharedConstants.AVL_SPEED_H0 = '_h0';
SharedConstants.AVL_SPEED_H1 = '_h1';
SharedConstants.AVL_SPEED_H2 = '_h2';
SharedConstants.AVL_SPEED_H3 = '_h3';
SharedConstants.AVL_SPEED_H4 = '_h4';
SharedConstants.AVL_SPEED_H5 = '_h5';
SharedConstants.AVL_SPEED_H6 = '_h6';
SharedConstants.AVL_SPEED_H7 = '_h7';
SharedConstants.AVL_SPEED_BEGINNING = 'styles/images/pp/pin30';
SharedConstants.DIALOG_OK_OPTION = 'OK';
SharedConstants.DIALOG_CANCEL_OPTION = 'CANCEL';
SharedConstants.RULESET_AFFECTED_DOCUMENT_ID = 'affectedDocId';
SharedConstants.RULESET_AFFECTED_TEMPLATE_ID = 'affectedTplId';
SharedConstants.RULESET_AFFECTED_FIELD_NAME = 'affectedFieldName';
SharedConstants.RULESET_NEW_FILTER = 'newFilter';
SharedConstants.RULESET_RESULT_FLAG = 'flag';
SharedConstants.RULESET_PARENT_DOCUMENT = 'parentDoc';
SharedConstants.RULESET_CHILD_DOCUMENT = 'childDoc';
SharedConstants.MAP_MARKER_ARROW = 'styles/images/arrow.png';
SharedConstants.MAP_PRIMARY_ASSET = 'styles/images/primary.png';
SharedConstants.MAP_SECONDARY_ASSET = 'styles/images/secondary.png';
SharedConstants.MAP_MARKER_GEOLOCATION = 'images/geolocation_marker_heading.png';
SharedConstants.EPSG_4326 = 'EPSG:4326';
SharedConstants.EPSG_3857 = 'EPSG:3857';
SharedConstants.STREET_SUBPREMISE = 'subpremise';
SharedConstants.STREET_STREET_NUMBER = 'street_number';
SharedConstants.STREET_ROUTE = 'route';
SharedConstants.STREET_ADMINISTRATIVE_AREA_LEVEL_1 = 'administrative_area_level_1';
SharedConstants.STREET_LOCALITY = 'locality';
SharedConstants.STREET_POSTAL_CODE = 'postal_code';
SharedConstants.PRIMARY_ASSET = '{' +
    '"type" : "Feature",' +
    '"properties" : {' +
    '"type" : "primaryAssets",' +
    '"linkAssets" : []' +
    '},' +
    '"geometry" : {' +
    '"type": "MultiPoint",' +
    '"coordinates" : []' +
    '}' +
    '}';
SharedConstants.SECONDARY_ASSET = '{' +
    '"type" : "Feature",' +
    '"properties" : {' +
    '"type" : "secondaryAssets",' +
    '"linkAssets": []' +
    '},' +
    '"geometry": {' +
    '"type": "MultiPoint",' +
    '"coordinates": []' +
    '}' +
    '}';
SharedConstants.STREET = '{"type":"Feature",' +
    '"properties":{' +
    '"type":"street",' +
    '"unitNo":"",' +
    '"streetNo":"",' +
    '"street":"",' +
    '"suburb":"",' +
    '"postcode":"",' +
    '"locationDescription":"",' +
    '"country":"",' +
    '"iconImage":"",' +
    '"iconSize":""' +
    '},' +
    '"geometry":{' +
    '"type":"Point",' +
    '"coordinates":[]' +
    '}' +
    '}';
SharedConstants.STREET_INITIAL = {
    type: 'Feature',
    properties: {
        type: 'street'
    }
};
SharedConstants.STREET_INITIAL_DATA = '{' +
    '"type": "FeatureCollection",' +
    '"features": [' +
    '{' +
    '"type" : "Feature",' +
    '"properties" : {' +
    '"type" : "street",' +
    '"unitNo" : "",' +
    '"streetNo" : "",' +
    '"street" : "",' +
    '"suburb" : "",' +
    '"postcode" : "",' +
    '"locationDescription" : "",' +
    '"country" : "",' +
    '"iconImage" : "",' +
    '"iconSize" : ""' +
    '},' +
    '"geometry" : {' +
    '"type" : "Point",' +
    '"coordinates": []' +
    '}' +
    '}' +
    ']' +
    '}';
SharedConstants.ASSET_FULL_INITIAL_DATA = '{' +
    '"type": "FeatureCollection",' +
    '"features": [' +
    '{' +
    '"type" : "Feature",' +
    '"properties" : {' +
    '"type" : "street",' +
    '"unitNo" : "",' +
    '"streetNo" : "",' +
    '"street" : "",' +
    '"suburb" : "",' +
    '"postcode" : "",' +
    '"locationDescription" : "",' +
    '"country" : "",' +
    '"iconImage" : "",' +
    '"iconSize" : ""' +
    '},' +
    '"geometry" : {' +
    '"type" : "Point",' +
    '"coordinates": []' +
    '}' +
    '},' +
    '{' +
    '"type" : "Feature",' +
    '"properties" : {' +
    '"type" : "primaryAssets",' +
    '"linkAssets" : []' +
    '},' +
    '"geometry" : {' +
    '"type" : "MultiPoint",' +
    '"coordinates" : []' +
    '}' +
    '},' +
    '{' +
    '"type" : "Feature",' +
    '"properties" : {' +
    '"type" : "secondaryAssets",' +
    '"linkAssets" : []' +
    '},' +
    '"geometry" : {' +
    '"type" : "MultiPoint",' +
    '"coordinates" : []' +
    '}' +
    '}' +
    ']' +
    '}';
SharedConstants.STREET_INITIAL_HEADER = {
    type: 'FeatureCollection',
    features: []
};
SharedConstants.checkListSeparator = '^';
SharedConstants.DEFAULT_MESSAGE_LENGTH = 200;
SharedConstants.DEFAULT_EXPIRY_DURATION_MINUTES = 60;
SharedConstants.MAKE_CURRENT_VERSION_KEY = 'makeCurrentVersion';
SharedConstants.IMPORT_PREVIOUS_VERSION = "importPreviousVersion";
SharedConstants.SEARCH_PROVIDERS = {
    COUCHBASE: 'couchbase',
    ELASTIC: 'elastic',
    MONGODB: 'mongodb'
};
SharedConstants.DOCUMENT_FIELD_NAME_UPLOAD_FILE = 'imageFileNo96'; // key used at systemHeader to refer to the uploaded file
// key used at systemHeader to refer to the uploaded file
SharedConstants.PASSWORD_RESET = "password:reset";
SharedConstants.DEFAULT_MAX_UPLOAD_SIZE = 50; //size in megabytes
if (false) {
    /** @type {?} */
    SharedConstants.APP_NAME;
    /** @type {?} */
    SharedConstants.SYSTEM_TYPE_DOCUMENT;
    /** @type {?} */
    SharedConstants.SYSTEM_TYPE_VERSION;
    /** @type {?} */
    SharedConstants.SYSTEM_TYPE_TEMPLATE;
    /** @type {?} */
    SharedConstants.SYSTEM_TYPE_ACCOUNT;
    /** @type {?} */
    SharedConstants.SYSTEM_TYPE_RULESET_DOCUMENT;
    /** @type {?} */
    SharedConstants.SYSTEM_TYPE_SYSTEM_ACTION;
    /** @type {?} */
    SharedConstants.SYSTEM_TYPE_SCHEDULE;
    /** @type {?} */
    SharedConstants.SYSTEM_TYPE_FILE_REFERENCE;
    /** @type {?} */
    SharedConstants.SYSTEM_TYPE_CONFIGURATION;
    /** @type {?} */
    SharedConstants.SYSTEM_TYPE_COMPONENT;
    /** @type {?} */
    SharedConstants.SYSTEM_TYPE_COUNTER;
    /** @type {?} */
    SharedConstants.SYSTEM_TYPE_PASSWORD_RESET;
    /** @type {?} */
    SharedConstants.SYSTEM_TYPE_ACCOUNT_SECURITY;
    /** @type {?} */
    SharedConstants.SYSTEM_TYPE_ACCOUNT_CONTROL;
    /** @type {?} */
    SharedConstants.SYSTEM_TYPE_ACCOUNT_GROUP_CONFIG;
    /** @type {?} */
    SharedConstants.SYSTEM_TYPE_PASSWORD;
    /** @type {?} */
    SharedConstants.SYSTEM_TYPE_RULESET;
    /** @type {?} */
    SharedConstants.SYSTEM_TYPE_RULESET_INCLUDE;
    /** @type {?} */
    SharedConstants.SYSTEM_TYPE_APPLICATION;
    /** @type {?} */
    SharedConstants.SYSTEM_TYPE_VENDOR_LIBRARY;
    /** @type {?} */
    SharedConstants.STATUS_PENDING;
    /** @type {?} */
    SharedConstants.STATUS_PROCESSING;
    /** @type {?} */
    SharedConstants.STATUS_PROCESSED;
    /** @type {?} */
    SharedConstants.STATUS_ERROR;
    /** @type {?} */
    SharedConstants.STATUS_SUCCESS;
    /** @type {?} */
    SharedConstants.STATUS_WARNING;
    /** @type {?} */
    SharedConstants.STATUS_INFO;
    /** @type {?} */
    SharedConstants.STATUS_FORBIDDEN;
    /** @type {?} */
    SharedConstants.METHOD_POST;
    /** @type {?} */
    SharedConstants.METHOD_GET;
    /** @type {?} */
    SharedConstants.METHOD_DELETE;
    /** @type {?} */
    SharedConstants.METHOD_PUT;
    /** @type {?} */
    SharedConstants.DEFAULT_PAGE;
    /** @type {?} */
    SharedConstants.DEFAULT_PAGE_SIZE;
    /** @type {?} */
    SharedConstants.DEFAULT_TOTAL_ITEM;
    /** @type {?} */
    SharedConstants.DEFAULT_SEARCH_DELAY;
    /** @type {?} */
    SharedConstants.DEFAULT_MAX_SEARCH_QUERY_LENGTH;
    /** @type {?} */
    SharedConstants.DEFAULT_SEARCH_SELECT_PAGE_SIZE;
    /** @type {?} */
    SharedConstants.DEFAULT_SEARCH_SELECT_PAGE;
    /** @type {?} */
    SharedConstants.FIELD_TYPE_RELATED;
    /** @type {?} */
    SharedConstants.FIELD_TYPE_HTML;
    /** @type {?} */
    SharedConstants.FIELD_TYPE_CUSTOM;
    /** @type {?} */
    SharedConstants.ELASTIC_DOCUMENT_TYPE;
    /** @type {?} */
    SharedConstants.ELASTIC_DOCUMENT_PREFIXES;
    /** @type {?} */
    SharedConstants.DEFAULT_DB_PROVIDER;
    /** @type {?} */
    SharedConstants.DEFAULT_DB_CONNECTION;
    /** @type {?} */
    SharedConstants.RULESET_EVENT_NAME;
    /** @type {?} */
    SharedConstants.RULESET_RELATIONSHIPS;
    /** @type {?} */
    SharedConstants.ONLOAD_DONE_RULES_EVENT_NAME;
    /** @type {?} */
    SharedConstants.ON_CHANGE_FILTER_EVENT_NAME;
    /** @type {?} */
    SharedConstants.LOCATION_CHANGE_STATE_EVENT;
    /** @type {?} */
    SharedConstants.UPDATE_SHOW_VALUE_EVENT;
    /** @type {?} */
    SharedConstants.EVENT_LIST_NAME;
    /** @type {?} */
    SharedConstants.EVENT_VALIDATION_VALUES_NAME;
    /** @type {?} */
    SharedConstants.INSERT_OPERATION_TYPE;
    /** @type {?} */
    SharedConstants.UPDATE_OPERATION_TYPE;
    /** @type {?} */
    SharedConstants.CSV_DOC_ID_MATCH_MERGE;
    /** @type {?} */
    SharedConstants.CSV_DOC_ID_MATCH_REPLACE;
    /** @type {?} */
    SharedConstants.CSV_DOC_ID_NO_MATCH_ADD;
    /** @type {?} */
    SharedConstants.CSV_DOC_ID_NO_MATCH_ERR;
    /** @type {?} */
    SharedConstants.SAVE_CLICK_OPERATION_TYPE;
    /** @type {?} */
    SharedConstants.NEW_CLICK_OPERATION_TYPE;
    /** @type {?} */
    SharedConstants.PRINT_CLICK_OPERATION_TYPE;
    /** @type {?} */
    SharedConstants.MAP_CLICK_OPERATION_TYPE;
    /** @type {?} */
    SharedConstants.OPERATION_TYPE_READ;
    /** @type {?} */
    SharedConstants.OPERATION_TYPE_CREATE;
    /** @type {?} */
    SharedConstants.OPERATION_TYPE_UPDATE;
    /** @type {?} */
    SharedConstants.OPERATION_TYPE_DELETE;
    /** @type {?} */
    SharedConstants.OPERATION_TYPE_EXECUTE;
    /** @type {?} */
    SharedConstants.OPERATION_TYPE_OFFLINE;
    /** @type {?} */
    SharedConstants.ERROR_TYPE_NOACCESS;
    /** @type {?} */
    SharedConstants.ERROR_TYPE_NOTFOUND;
    /** @type {?} */
    SharedConstants.ERROR_TYPE_INTERNAL;
    /** @type {?} */
    SharedConstants.ERROR_TYPE_GONE;
    /** @type {?} */
    SharedConstants.WEB_SOCKET_MESSAGE_TEMPLATE_DRAFT_SAVED;
    /** @type {?} */
    SharedConstants.WEB_SOCKET_MESSAGE_UPDATE_PREVIEW;
    /** @type {?} */
    SharedConstants.WEB_SOCKET_MESSAGE_SAVE_DOCUMENT;
    /** @type {?} */
    SharedConstants.WEB_SOCKET_MESSAGE_PASSWORD_RESET;
    /** @type {?} */
    SharedConstants.HEADING_THRESHOLD_H0;
    /** @type {?} */
    SharedConstants.HEADING_THRESHOLD_H1;
    /** @type {?} */
    SharedConstants.HEADING_THRESHOLD_H2;
    /** @type {?} */
    SharedConstants.HEADING_THRESHOLD_H3;
    /** @type {?} */
    SharedConstants.HEADING_THRESHOLD_H4;
    /** @type {?} */
    SharedConstants.HEADING_THRESHOLD_H5;
    /** @type {?} */
    SharedConstants.HEADING_THRESHOLD_H6;
    /** @type {?} */
    SharedConstants.HEADING_THRESHOLD_H7;
    /** @type {?} */
    SharedConstants.AVL_SPEED_H0;
    /** @type {?} */
    SharedConstants.AVL_SPEED_H1;
    /** @type {?} */
    SharedConstants.AVL_SPEED_H2;
    /** @type {?} */
    SharedConstants.AVL_SPEED_H3;
    /** @type {?} */
    SharedConstants.AVL_SPEED_H4;
    /** @type {?} */
    SharedConstants.AVL_SPEED_H5;
    /** @type {?} */
    SharedConstants.AVL_SPEED_H6;
    /** @type {?} */
    SharedConstants.AVL_SPEED_H7;
    /** @type {?} */
    SharedConstants.AVL_SPEED_BEGINNING;
    /** @type {?} */
    SharedConstants.DIALOG_OK_OPTION;
    /** @type {?} */
    SharedConstants.DIALOG_CANCEL_OPTION;
    /** @type {?} */
    SharedConstants.RULESET_AFFECTED_DOCUMENT_ID;
    /** @type {?} */
    SharedConstants.RULESET_AFFECTED_TEMPLATE_ID;
    /** @type {?} */
    SharedConstants.RULESET_AFFECTED_FIELD_NAME;
    /** @type {?} */
    SharedConstants.RULESET_NEW_FILTER;
    /** @type {?} */
    SharedConstants.RULESET_RESULT_FLAG;
    /** @type {?} */
    SharedConstants.RULESET_PARENT_DOCUMENT;
    /** @type {?} */
    SharedConstants.RULESET_CHILD_DOCUMENT;
    /** @type {?} */
    SharedConstants.MAP_MARKER_ARROW;
    /** @type {?} */
    SharedConstants.MAP_PRIMARY_ASSET;
    /** @type {?} */
    SharedConstants.MAP_SECONDARY_ASSET;
    /** @type {?} */
    SharedConstants.MAP_MARKER_GEOLOCATION;
    /** @type {?} */
    SharedConstants.EPSG_4326;
    /** @type {?} */
    SharedConstants.EPSG_3857;
    /** @type {?} */
    SharedConstants.STREET_SUBPREMISE;
    /** @type {?} */
    SharedConstants.STREET_STREET_NUMBER;
    /** @type {?} */
    SharedConstants.STREET_ROUTE;
    /** @type {?} */
    SharedConstants.STREET_ADMINISTRATIVE_AREA_LEVEL_1;
    /** @type {?} */
    SharedConstants.STREET_LOCALITY;
    /** @type {?} */
    SharedConstants.STREET_POSTAL_CODE;
    /** @type {?} */
    SharedConstants.PRIMARY_ASSET;
    /** @type {?} */
    SharedConstants.SECONDARY_ASSET;
    /** @type {?} */
    SharedConstants.STREET;
    /** @type {?} */
    SharedConstants.STREET_INITIAL;
    /** @type {?} */
    SharedConstants.STREET_INITIAL_DATA;
    /** @type {?} */
    SharedConstants.ASSET_FULL_INITIAL_DATA;
    /** @type {?} */
    SharedConstants.STREET_INITIAL_HEADER;
    /** @type {?} */
    SharedConstants.checkListSeparator;
    /** @type {?} */
    SharedConstants.DEFAULT_MESSAGE_LENGTH;
    /** @type {?} */
    SharedConstants.DEFAULT_EXPIRY_DURATION_MINUTES;
    /** @type {?} */
    SharedConstants.MAKE_CURRENT_VERSION_KEY;
    /** @type {?} */
    SharedConstants.IMPORT_PREVIOUS_VERSION;
    /** @type {?} */
    SharedConstants.SEARCH_PROVIDERS;
    /** @type {?} */
    SharedConstants.DOCUMENT_FIELD_NAME_UPLOAD_FILE;
    /** @type {?} */
    SharedConstants.PASSWORD_RESET;
    /** @type {?} */
    SharedConstants.DEFAULT_MAX_UPLOAD_SIZE;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/types/error-component-definition.type.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ErrorComponentDefinition() { }
if (false) {
    /** @type {?} */
    ErrorComponentDefinition.prototype.errorMessage;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: formbird-types.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ChangeSourceInfo, ChangeSourceType, FormbirdTypesModule, FtError, SharedConstants, StateChangeInfo, SystemHeader };
//# sourceMappingURL=formbird-types.js.map
